<template>
  <div
    class="grow shrink self-stretch p-5 md:px-6 md:py-5 bg-racq-anti-flash-white justify-start items-start gap-4 flex flex-col md:flex-row rounded"
  >
    <div class="grow shrink justify-start items-start gap-4 md:gap-5 flex">
      <Image v-if="fields.icon?.value" :media="fields.icon" class="w-12 h-12" />
      <div class="grow shrink flex-col justify-start items-start inline-flex">
        <RichText v-if="fields.title" class="text-racq-dark-grey text-base-bold" :field="fields.title" />
        <RichText v-if="fields.subTitle" class="text-racq-dark-grey text-m" :field="fields.subTitle" />
      </div>
    </div>
    <FormKit
      v-if="fields.buttonText?.value"
      type="button"
      :label="fields.buttonText?.value"
      inputClass="btn btn-md md:btn-sm btn-secondary w-full md:w-max"
      outerClass="w-full md:w-max"
      @click="buttonClicked"
      :disabled="isButtonDisabled ?? false"
    />
  </div>
</template>

<script setup lang="ts">
import { Field, RichText, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageFieldValue } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';

const props = defineProps<{
  fields: {
    icon?: Field<ImageFieldValue>;
    title: Field<string>;
    subTitle: Field<string>;
    buttonText?: Field<string>;
  },
  isButtonDisabled?: boolean
}>();

// Define Component state
// ------------------------------------------------------------- //
const emit = defineEmits(['buttonClicked']);

// Functions
// ------------------------------------------------------------- //

const buttonClicked = (values: any) => {
  emit('buttonClicked', values);
};
</script>
